import { Facebook, Globe2, Instagram } from "lucide-react";

const networks = [
  { labelKey: "instagram", urlKey: "instagramUrl", fallback: "Instagram", icon: Instagram },
  { labelKey: "facebook", urlKey: "facebookUrl", fallback: "Facebook", icon: Facebook },
  { labelKey: "website", urlKey: "websiteUrl", fallback: "Sitio web", icon: Globe2 },
];

export function externalHref(value) {
  const trimmed = String(value || "").trim();
  if (!trimmed) return "";
  const candidate = /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
  try {
    const parsed = new URL(candidate);
    return ["http:", "https:"].includes(parsed.protocol) ? parsed.toString() : "";
  } catch {
    return "";
  }
}

export default function SocialLinks({ social = {}, className = "", linkClassName = "" }) {
  const links = networks
    .map((network) => ({ ...network, href: externalHref(social[network.urlKey]) }))
    .filter(({ href }) => href);
  if (!links.length) return null;

  return (
    <div className={className}>
      {links.map(({ labelKey, urlKey, fallback, icon: Icon, href }) => (
        <a
          key={urlKey}
          href={href}
          target="_blank"
          rel="noreferrer"
          className={`inline-flex items-center gap-2 link-underline ${linkClassName}`}
        >
          <Icon size={15} aria-hidden="true" />
          <span>{social[labelKey] || fallback}</span>
        </a>
      ))}
    </div>
  );
}
